import React, { useContext, useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
import axiosInstance from "../axiosConfig";
import { AuthContext } from "../AuthContext";
import Logo from "../assets/Img/Logo-1.png";
import User from "../assets/Img/User.gif";
import DataTable from "react-data-table-component";
import { PieChart, Pie, Cell, Tooltip } from "recharts";
import StaffAttendance from "../components/StaffAttendance";

function StaffDashboard() {
  const { user, logout } = useContext(AuthContext);
  const [department, setDepartment] = useState("Not Assigned");
  const [taskData, setTaskData] = useState([]);
  const [performanceData, setPerformanceData] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [currentPage, setCurrentPage] = useState(1);
  const [taskCounts, setTaskCounts] = useState({ TotalTasks: 0, Completed: 0, Pending: 0 });
  const itemsPerPage = 5; // Number of items per page for mobile view
//   const [, setTotalAmount] = useState(0);
  // ← new piece of state
  const [overallScore, setOverallScore] = useState(0);
// New Table Data 
  const [displayColumns, setDisplayColumns] = useState([]);  // start empty
const [overallData, setOverallData] = useState([]);
const [overallPage, setOverallPage] = useState(1);
const overallPerPage = 5;


  useEffect(() => {
    const fetchPerformanceData = async () => {
      try {
        const response = await axiosInstance.get("api/get-Performance");
        const filteredPerformance = response.data.find(
          (item) => item.EmployeeName === user?.Name
        );
        setPerformanceData(filteredPerformance || null);
      } catch (error) {
        console.error("Error fetching performance data:", error);
      }
    };

    fetchPerformanceData();
  }, [user?.Name]);
 
  
 
  // ← fetch it once on mount (or whenever your user changes)
  useEffect(() => {
    async function loadOverall() {
      try {
        const { data } = await axiosInstance.get(
          "/api/get-EmployeeOverallPerformance"
        );
        const me = data.find((r) => r.staff_name === user?.Name);
        setOverallScore(me?.overall_performance ?? 0);
      } catch (err) {
        console.error("couldn't load overall performance", err);
      }
    }
    if (user?.Name) loadOverall();
  }, [user?.Name]);


//// this is for table 
useEffect(() => {
  const fetchOverall = async () => {
    const res = await axiosInstance.get("/api/get-EmployeeOverallPerformance");
    const mine = res.data.filter(row => row.staff_name === user?.Name);
    setOverallData(mine);

    // 3) Prune out columns with all-null values
    const cols = overallColumns.filter(col => 
      mine.some(row => {
        const value = col.selector(row);
        return value !== null && value !== undefined;
      })
    );
    setDisplayColumns(cols);
  };
  fetchOverall();
}, [user?.Name]);
  
  // useEffect(() => {
  //   const fetchTaskData = async () => {
  //     try {
  //       const response = await axiosInstance.get("api/get-AllTasks");
  //       let filteredTasks = response.data.filter((item) => item.EmployeeName === user?.Name);

  //       // ✅ Categorize tasks
  //       let completedCount = filteredTasks.filter((task) => task.Status === "Completed" || task.Status === "Resolved").length;
  //       let pendingCount = filteredTasks.filter((task) => task.Status === "Pending").length;

  //       // ✅ Get Total Tasks from Performance API
  //       const perfResponse = await axiosInstance.get("api/get-Performance");
  //       const totalTasks = perfResponse.data.find((item) => item.EmployeeName === user?.Name)?.TotalTasks || 0;

  //       setTaskCounts({
  //         TotalTasks: totalTasks,
  //         Completed: completedCount,
  //         Pending: pendingCount,
  //       });

  //       setTaskData(filteredTasks);

  //       const handleResize = () => {
  //         setIsMobile(window.innerWidth <= 768);
  //       };

  //       window.addEventListener("resize", handleResize);
  //       return () => window.removeEventListener("resize", handleResize);
  //     } catch (error) {
  //       console.error("Error fetching task data:", error);
  //     }
  //   };

  //   fetchTaskData();
  // }, [user?.Name]);

  useEffect(() => {
  const fetchTaskData = async () => {
    try {
      const { data } = await axiosInstance.get("api/get-AllTasks");
      // Only keep this user’s rows:
      const mine = data.filter((t) => t.EmployeeName === user?.Name);

      // Now compute all three counts from that array:
      const totalTasks     = mine.length;
      const completedCount = mine.filter((t) => t.Status === "Completed" || t.Status === "Resolved").length;
      const pendingCount   = mine.filter((t) => t.Status === "Pending").length;

      setTaskCounts({
        TotalTasks: totalTasks,
        Completed: completedCount,
        Pending: pendingCount,
      });

      setTaskData(mine);
    } catch (err) {
      console.error("Error fetching task data:", err);
    }
  };

  fetchTaskData();
}, [user?.Name]);

  const totalPages = Math.ceil(taskData.length / itemsPerPage);
  const paginatedData = taskData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const nextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const prevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };
//end

  // Fetch user department
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axiosInstance.get("/api/AllUsers");
        const users = response.data;

        const userDepartment = users.find(
          (u) => u.EmployeeID === user?.EmployeeID
        )?.Department;
        setDepartment(userDepartment || "Not Assigned");
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };



    fetchUsers();
    // fetchTemporaryDepartments();
  }, [user?.EmployeeID]);
  //end
  useEffect(() => {
    const checkSessionExpiration = () => {
      const sessionExpiration = localStorage.getItem("sessionExpiration");
      const currentTime = new Date();

      if (!sessionExpiration || currentTime > new Date(sessionExpiration)) {
        // handleLogout(); // Automatically logout if session expires
        window.location.reload(); // Reload the page after logout
      }
    };

    // Check session expiration immediately
    checkSessionExpiration();

    // Optionally, check periodically (e.g., every 5 seconds)
    const interval = setInterval(checkSessionExpiration, 5000);

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, []);

/// Date Convert into IST Format
  const convertToIST = (utcDate) => {
    if (!utcDate) return "N/A"; // Handle null values gracefully
  
    const date = new Date(utcDate);
    return date.toLocaleString("en-IN", { 
      timeZone: "Asia/Kolkata", 
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true
    });
  };

    // /// ✅ Pie Chart Data
    // const chartData = performanceData
    // ? [
    //     { name: "Total Tasks", value: performanceData.TotalTasks },
    //     { name: "Completed Tasks", value: performanceData.CompletedTasks },
    //     { name: "On-Time Tasks", value: performanceData.OnTimeTasks },
    //     {
    //       name: "Performance Score",
    //       value: performanceData.CombinedPerformanceScore,
    //     },
    //   ]
    // : [];
 // ✅ Pie Chart Data
//  const chartData = [
//   { name: "Completed", value: taskCounts.Completed },
//   { name: "Pending", value: taskCounts.Pending },
//   // { name: "Total Tasks", value: taskCounts.TotalTasks },
// ];
// …inside StaffDashboard(), after you’ve fetched overallScore…
const chartData = [
  { name: "", value: overallScore },
  { name: "", value: 100 - overallScore },
];

  // const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"];

  const COLORS = ["#00C49F", "#FFBB28", "#0088FE"];

  // const renderCustomizedLabel = ({ cx, cy }) => {
  //   const performanceScore = performanceData ? performanceData.CombinedPerformanceScore : 0;
  //   let scoreColor;
  //   if (performanceScore < 50) {
  //     scoreColor = "red"; // 🔴 Below 50
  //   } else if (performanceScore >= 50 && performanceScore < 80) {
  //     scoreColor = "orange"; // 🟠 Between 50-80
  //   } else {
  //     scoreColor = "green"; // 🟢 Above 80
  //   }
  
  //   return (
  //     <text
  //       x={cx}
  //       y={cy}
  //       fill={scoreColor}
  //       textAnchor="middle"
  //       dominantBaseline="central"
  //       fontSize="24px"
  //       fontWeight="bold"
  //     >
  //       {performanceScore}%
  //     </text>
  //   );
  // };
 
   // now your label renderer just reads from that
  const renderCustomizedLabel = ({ cx, cy }) => {
    const score = overallScore;
    let color = score < 50 ? "red" : score < 80 ? "orange" : "green";

    return (
      <text
        x={cx}
        y={cy}
        fill={color}
        textAnchor="middle"
        dominantBaseline="central"
        fontSize="24px"
        fontWeight="bold"
      >
        {score}%
      </text>
    );
  };


const overallColumns = [
  { name: "Staff Name", selector: row => row.staff_name, sortable: true },
  // { name: "Role",       selector: row => row.role_work,  sortable: true },
  { name: "Tasks",      selector: row => row.no_of_tasks, sortable: true },
  { name: "Planner",    selector: row => row.planner_performance_score, sortable: true },
  { name: "Foam Cutting Target",    selector: row => row.manager_performance_score, sortable: true },
  { name: "Supervisor Performance", selector: row => row.supervisor_performance_score, sortable: true },
  { name: "Sales Flow Performance", selector: row => row.sales_flow_performance_score, sortable: true },
  { name: "RM Stock Verfication", selector: row => row.notifications_performance_score, sortable: true },
  { name: "Cost Sheet Approval",    selector: row => row.cost_sheet_approval_performance_score, sortable: true },
  // { name: "Social Media",  selector: row => row.social_media_performance_score, sortable: true },
  { name: "Purchase Cmp",  selector: row => row.purchase_comparison_score, sortable: true },
  { name: "Sales Cmp",     selector: row => row.sales_comparison_score, sortable: true },
  { name: "PO for alloted Items",      selector: row => row.po_score, sortable: true },
   { name: "SupervisorManagerRedScore",      selector: row => row.SupervisorManagerRedScore, sortable: true },
  { name: "Overall Performance",     selector: row => `${row.overall_performance}%`, sortable: true },
  
];
const overallTotalPages = Math.ceil(overallData.length / overallPerPage);
const overallPageData = overallData.slice(
  (overallPage - 1) * overallPerPage,
  overallPage * overallPerPage
);

  const columns = [
    { name: "Employee Name", selector: (row) => row.EmployeeName, sortable: true },
    { name: "Task Title", selector: (row) => (
        <span
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        title={row.TaskName}
        >
        {row.TaskName}
        </span>
    ), sortable: true },
     { name: "Priority", selector: (row) => (row.Priority), sortable: true },
    { name: "Due Date", selector: (row) => convertToIST(row.DueDate), sortable: true },
    { name: "Completed Date", selector: (row) => convertToIST(row.CompletedDate), sortable: true },
    { name: "Status", selector: (row) => row.Status, sortable: true },
  ];

    // Adjust PieChart size based on screen width
    // const chartSize = isMobile ? 250 : 400;


    
  return (
    <div className=" ">
            <div id="alertPlaceholder"></div>
      <nav className="navbar navbar-expand-lg bg-body-white" style={{boxShadow:"0 1px 5px rgba(0, 0, 0, 0.2) "}}>
        <div className="container-fluid">
          <a className="navbar-brand">
            {" "}
            <img
              src={Logo}
              className="img-fluid rounded-top"
              alt="Logo"
              style={{ height: "40px", marginLeft: "40px" }}
            />
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div
            className="collapse navbar-collapse"
            id="navbarSupportedContent"
          ></div>
        </div>
        {/* Navbar Links and Profile Dropdown */}
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0"></ul>
          <span style={{marginLeft:"-21rem"}}>Welcome,{user?.Name}! </span>
          {/* Profile Dropdown */}
          <div className="dropdown">
            <a
              className="d-flex align-items-center text-decoration-none dropdown-toggle ml-5 "
              // href="#"
              role="button"
              id="dropdownMenuLink"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              style={{
                marginRight: "20px",
                justifyContent: "end",
                marginLeft: "10px",
              }}
            >
              <img
                src={User}
                alt="Profile"
                className="rounded-circle"
                style={{
                  width: "40px",
                  height: "40px",
                  objectFit: "cover",
                }}
              />
            </a>
            <ul
              className="dropdown-menu dropdown-menu-end"
              aria-labelledby="dropdownMenuLink"
            >
              {/* <li>
                  <a className="dropdown-item" href="#">
                    My Profile
                  </a>
                </li> */}
              <li>
                <a
                  className="dropdown-item text-danger"
                  // href="#"
                  // onClick={handleLogout}
                  onClick={logout}
                >
                  Logout
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      {/* <main>
        <div className="container">
          <p>Employee ID: {user?.EmployeeID}</p>
          <p>Department: {department}</p>
          <p>Assigned Department: {temporaryDepartment}</p>
        </div>
      </main> */}
       <div className="dashboard-container" style={{ background: "#f7f9fc", height: "-webkit-fill-available" }}>
      <main style={{ padding: "20px" }}>
        <div className="dashboard-content" style={{ maxWidth: "800px", margin: "0 auto" }}>
        <StaffAttendance user={user} department={department} />
        <div className="card d-flex align-items-center" style={{
              background: "white",
              padding: "20px",
              borderRadius: "8px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              marginBottom: "20px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              paddingTop: "0px",
            }}>
           {/* <p style={{  color: "black", marginBottom: "8px" }}>
              <strong>Department:</strong> {department || "Not Assigned"}
            </p>
           
             {performanceData && (
            <>
              <p><strong>Total Tasks:</strong> {performanceData.TotalTasks}</p>
              <p><strong>Completed Tasks:</strong> {performanceData.CompletedTasks}</p>
              <p><strong>On-Time Tasks:</strong> {performanceData.OnTimeTasks}</p>
              <p><strong>Performance Score:</strong> {performanceData.CombinedPerformanceScore}%</p>
              <PieChart width={400} height={300}>
                    <Pie data={chartData} cx="50%" cy="50%" innerRadius={60} outerRadius={100} fill="#8884d8" paddingAngle={4} dataKey="value">
                      {chartData.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                      ))}
                    </Pie>
                    <Tooltip />
                    <Legend />
                  </PieChart>
            
            </>
             )} */}
                {/* ✅ Left Side: Performance Data */}
                <div>
                <p style={{ color: "black", marginBottom: "8px" }}>
                  <strong>Department:</strong> {department || "Not Assigned"}
                </p>
                {performanceData && (
                  <>
                    <p><strong>Total Tasks:</strong> {taskCounts.TotalTasks}</p>
                    <p><strong>Completed Tasks:</strong> {taskCounts.Completed}</p>
                    <p><strong>Pending tasks</strong> {taskCounts.Pending}</p>
                    {/* <p><strong>Task Completion Score:</strong> {performanceData.CombinedPerformanceScore}%</p> */}
                  </>
                )}
                    {overallData && (
                  <>
                  <p>
                    <strong>Overall Performance:</strong> {overallScore}%
                  </p>
                  </>
                )}
              </div>
             {/* ✅ Right Side: Pie Chart */}
                <div className="PieChart_css" style={{ display: "flex", justifyContent: "center" }}>
                
                  {/* { taskCounts.TotalTasks > 0 && (
                <PieChart width={400} height={300}>
                  <Pie
                    data={chartData}
                    cx="50%"
                    cy="50%"
                    innerRadius={60}
                    outerRadius={100}
                    dataKey="value"
                    label={renderCustomizedLabel}
                    paddingAngle={4}
                    labelLine={false}
                  >
                    {chartData.map((entry, index) => (
                      <Cell key={index} fill={COLORS[index % COLORS.length]} />
                    ))}
                  </Pie>
                  <Tooltip />
                  <Legend />
                </PieChart>
              )} */}
          
              {overallScore > 0 && (
                <PieChart width={400} height={300}>
                  <Pie
                    data={chartData}
                    cx="50%"
                    cy="50%"
                    innerRadius={60}
                    outerRadius={100}
                    dataKey="value"
                    label={renderCustomizedLabel}
                    paddingAngle={4}
                    labelLine={false}
                  >
                    {chartData.map((entry, index) => (
                      <Cell key={index} fill={COLORS[index % COLORS.length]} />
                    ))}
                  </Pie>
                  {/* 
                    The formatter here makes the tooltip read “Overall Performance: 62.96%”
                    or “Remaining: 37.04%”.
                  */}
                    {/* Tooltip formatter: rounds value to two decimals and adds “%” */}
                    <Tooltip formatter={(value) => [`${Number(value).toFixed(2)}%`]} />
                  {/* <Legend /> */}
                </PieChart>
              )}
                </div>
                
          </div>

          
        </div>

      <style>
        {`
         @media (max-width: 768px) {
          .recharts-wrapper {
            padding: 57px !important;
          } 
            .recharts-tooltip-wrapper{
            left: -95px !important;
            }
            .recharts-default-legend {
            padding: 0px;
         
            text-align: center;
              margin: 38px !important;
              margin-top: -71px !important;
              margin-left: 29px !important;
            }
              .PieChart_css {
               margin:-135px !important;
               margin-top: -140px !important;
               overflow: hidden; /* Hide horizontal overflow */
              }
            .dashboard-container {
              overflow-x: hidden; /* ✅ Fix horizontal scrolling */
              width: 100vw; /* Ensure it doesn't extend past the viewport */
            }
          }
        `}
      </style>
     <div>
      <p style={{marginLeft:"25px"}}><strong>Note –</strong>{" "} <span className="text-danger"> Attendance will be factored into the Overall Performance Score at the end of the month.</span></p>
     </div>
     <div className="container mt-2" style={{ boxShadow: "0 1px 5px rgba(0, 0, 0, 0.51)", borderRadius: "5px", padding: "6px" }}>
  {/* <h4>📊 Team Overall Performance</h4> */}

  {!isMobile ? (
    <DataTable
      columns={displayColumns}
      data={overallData}
      pagination
      highlightOnHover
    />
  ) : (
    <>
      <div className="row">
        {overallPageData.map((row, idx) => (
          <div className="col-12 mb-3" key={idx}>
            <div className="card p-3 shadow-sm">
              <h6>{row.staff_name}</h6>
                <p><strong>Tasks:</strong> {row.no_of_tasks}</p>
                <p><strong>planner score:</strong> {row.planner_performance_score}%</p>
                <p><strong>Overall:</strong> {row.overall_performance}%</p>
            </div>
          </div>
        ))}
      </div>
      {overallTotalPages > 1 && (
        <div className="d-flex justify-content-between">
          <button
            className="btn btn-sm btn-outline-primary"
            onClick={() => setOverallPage(op => Math.max(op - 1, 1))}
            disabled={overallPage === 1}
          >
            Prev
          </button>
          <span>Page {overallPage} / {overallTotalPages}</span>
          <button
            className="btn btn-sm btn-outline-primary"
            onClick={() => setOverallPage(op => Math.min(op + 1, overallTotalPages))}
            disabled={overallPage === overallTotalPages}
          >
            Next
          </button>
        </div>
      )}
    </>
      )}
    </div>

      <div className="mt-3" style={{ marginLeft: "25px" }}>
        <p>
          <strong>Note –</strong>{" "}
          <span className="text-danger">
            Tasks that do not have an assigned due date will be scheduled based on
            their priority level as follows:
          </span>
        </p>
        <ul style={{ listStyleType: "disc", paddingLeft: "20px", marginTop: "-10px" }}>
          <li>
            <strong>Urgent</strong> – due within 24 hours
          </li>
          <li>
            <strong>Important</strong> – due within 48 hours
          </li>
          <li>
            <strong>Medium</strong> – due within 72 hours
          </li>
        </ul>
      </div>

        <div className="container mt-4" style={{ boxShadow: "0 1px 5px rgba(0, 0, 0, 0.51)", borderRadius: "5px", padding: "6px" }}>
          {!isMobile ? (
            <DataTable columns={columns} data={taskData} pagination highlightOnHover />
          ) : (
            <>
              <div className="row">
                {paginatedData.length > 0 ? (
                paginatedData.map((item, index) => (
                  <div className="col-12 mb-3 mt-2" key={index}>
                    <div className="card p-3 shadow-sm">
                      <h5 className="card-title">{item["EmployeeName"]}</h5>
                      <p className="card-text"><strong>Title:</strong> {item.TaskName}</p>
                      <p className="card-text"><strong>Priority:</strong> {item.Priority}</p>
                      <p className="card-text"><strong>DueDate:</strong> {convertToIST(item.DueDate)}</p>
                      <p className="card-text"><strong>CompletedDate:</strong> {convertToIST(item.CompletedDate)}</p>
                      <p className="card-text"><strong>Status:</strong> {item.Status}</p>
                    </div>
                  </div>
                ))
                ) : (
                  <div className="col-12 text-center mt-3">
                    <p>No data found.</p>
                  </div>
                )}               
              </div>

              {totalPages > 1 && (
                <div className="d-flex justify-content-between mt-3">
                  <button className="btn btn-primary mb-3" onClick={prevPage} disabled={currentPage === 1}>
                    Previous
                  </button>
                  <span>Page {currentPage} of {totalPages}</span>
                  <button className="btn btn-primary mb-3" onClick={nextPage} disabled={currentPage === totalPages}>
                    Next
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </main>
      
    </div>
    </div>
  );
}

export default StaffDashboard;
